import React from 'react'
import { Card, Grid, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'
import InfoIcon from '@mui/icons-material/Info'
import { colors } from '../../../themes/dapp'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit,
        backgroundColor: colors.tertiary.light,
        color: theme.palette.common.white,
        padding: theme.spacing.unit * 2,
    },
    message: {
        color: theme.palette.common.white,
    },
})

export interface InformationProperties extends WithStyles<typeof styles> {
    message: string
}

export const Information = withStyles(styles)(({ classes, message }: InformationProperties) => {
    return (
        <Card className={classes.root}>
            <Grid container spacing={3} direction="row" alignItems="center">
                <Grid item xs={1}>
                    <InfoIcon />
                </Grid>
                <Grid item xs={11}>
                    <Typography gutterBottom variant="caption" className={classes.message}>
                        {message}
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    )
})
